export const POML_VERSION = "0.0.7";
//# sourceMappingURL=version.js.map